import { Autocomplete, TextField } from "@mui/material";

import { Controller } from "react-hook-form";
import React from "react";

interface IFormInput {
    id?: string;
    name: string;
    label: string;
    control: any;
    error: any;
    disabled?: boolean;
    readOnly?: any;
    startOnFocus?: boolean;
    startValue?: any;
    options: any;
    onChange?: (value: string | number | {}) => void;
    concatWithID?: boolean;
    onInputChange?: any;
    placeholder?: string;
}

const textField: React.FC<IFormInput> = ({
    id,
    name,
    label,
    options,
    control,
    error,
    readOnly,
    disabled,
    startValue,
    startOnFocus,
    onChange,
    concatWithID: concat,
    onInputChange,
    placeholder,
}) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange: renderChange, value } }) => (
                <Autocomplete
                    id={id}
                    clearText="Limpar"
                    openText="Abrir"
                    closeText="Fechar"
                    noOptionsText="Nenhum registro"
                    disabled={disabled}
                    options={options}
                    readOnly={readOnly}
                    value={
                        options.find((item: { value: any }) => {
                            return item?.value === value || item?.value === startValue;
                        }) || null
                    }
                    getOptionLabel={(option) => {
                        if (option.value?.toString().toLowerCase() === option.label.toString().toLowerCase()) {
                            return option.label || "";
                        }
                        if (concat) {
                            return `${option.value} - ${option.label}` || "";
                        }
                        return `${option.label}` || "";
                    }}
                    onChange={(_, item) => {
                        renderChange(item?.value || "");
                        if (typeof onChange === "function")
                            onChange(item?.tipo ? { ...item } : item?.value ? item.value : "");
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            autoFocus={startOnFocus}
                            size="small"
                            margin="normal"
                            label={label}
                            error={!!error && !!error[name]}
                            helperText={!!error && error[name]?.message}
                            fullWidth
                            placeholder={placeholder}
                        />
                    )}
                    onInputChange={onInputChange}
                />
            )}
        />
    );
};

export default textField;
